module.exports = __webpack_public_path__ + "pen@2x.png?913b22ea058ff986468041517db1c124";